module.exports = __webpack_public_path__ + "img/97.db857c40.jpg";